import { SOLUTIONS } from "../data/content";

const CTA_LABELS = {
  contact: "Contact page (direct)",
  "contact-nav": "Header “Get Funding” button",
  "contact-mobile-nav": "Mobile menu “Get Funding”",
  "contact-home-hero": "Homepage hero CTA",
  "contact-home-final-cta": "Homepage bottom CTA",
  "contact-footer": "Footer “Get Funding” button",
  "contact-floating-cta": "Floating mobile CTA",
  "contact-calculator": "Finance calculator “Apply”",
  "contact-blog": "Knowledge Hub article CTA",
  "contact-business-finance": "Business Finance page CTA",
};

export function sourceLabel(key) {
  if (CTA_LABELS[key]) return CTA_LABELS[key];
  if (key.startsWith("landing-")) {
    const s = SOLUTIONS.find((x) => x.slug === key.slice(8));
    return `${s ? s.title : key.slice(8)} landing page`;
  }
  return key;
}

function Bars({ rows, total, testId }) {
  if (!rows.length) return <p className="text-grey text-sm">No enquiries yet.</p>;
  const max = rows[0].count;
  return (
    <ul className="space-y-3" data-testid={testId}>
      {rows.map((r) => (
        <li key={r.key} data-testid={`${testId}-row-${r.key}`}>
          <div className="flex items-baseline justify-between gap-4 text-sm">
            <span className="text-white/90 truncate">{r.label}</span>
            <span className="shrink-0 tabular-nums"><span className="font-bold">{r.count}</span><span className="text-grey"> · {total ? Math.round((r.count / total) * 100) : 0}%</span>{r.last_30 !== undefined && <span className="text-lime ml-2 text-xs">+{r.last_30} in 30d</span>}</span>
          </div>
          <div className="h-1.5 bg-[#111] mt-1.5"><div className="h-full bg-lime" style={{ width: `${(r.count / max) * 100}%` }} /></div>
        </li>
      ))}
    </ul>
  );
}

export function SourceBreakdown({ stats }) {
  if (!stats) return null;
  const total = stats.totals.leads;
  const sources = stats.by_source.map((r) => ({ ...r, label: sourceLabel(r.key) }));
  const landing = sources.filter((r) => r.key.startsWith("landing-"));
  const ctas = sources.filter((r) => !r.key.startsWith("landing-"));
  const types = stats.by_funding_type.map((r) => ({ ...r, label: r.key === "unknown" ? "Not specified" : r.key }));
  return (
    <section data-testid="source-breakdown" className="mt-8 grid lg:grid-cols-3 gap-px bg-[#808080]/20 border border-[#808080]/20">
      <div className="bg-[#1A1A1A] p-6 md:p-8">
        <h2 className="text-xs uppercase tracking-widest text-lime mb-1">Landing pages</h2>
        <p className="text-grey text-xs mb-6">Enquiries submitted on product landing pages</p>
        <Bars rows={landing} total={total} testId="stats-landing" />
      </div>
      <div className="bg-[#1A1A1A] p-6 md:p-8">
        <h2 className="text-xs uppercase tracking-widest text-lime mb-1">Calls to action</h2>
        <p className="text-grey text-xs mb-6">Which button sent the visitor to the contact form</p>
        <Bars rows={ctas} total={total} testId="stats-cta" />
      </div>
      <div className="bg-[#1A1A1A] p-6 md:p-8">
        <h2 className="text-xs uppercase tracking-widest text-lime mb-1">Funding type requested</h2>
        <p className="text-grey text-xs mb-6">Across all {total} enquiries</p>
        <Bars rows={types} total={total} testId="stats-type" />
      </div>
    </section>
  );
}
